var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDummyAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 37,
    y: 14,
    width: 47.1429,
    height: 60,
    rx: 23.5714,
    fill: "#BDBDBD"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 104.722V96.0429C20 87.4119 26.9969 80.415 35.6279 80.415H84.3721C93.0031 80.415 100 87.4119 100 96.0429V104.722C89.3849 114.223 75.3671 120 60 120C44.6329 120 30.6151 114.223 20 104.722Z",
    fill: "#BDBDBD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyAvatar);
export default __webpack_public_path__ + "static/media/dummyAvatar.2428035bd23abd7fc3627078c689c58a.svg";
export { ForwardRef as ReactComponent };